import * as React from 'react';
import styled from 'styled-components';

interface IAquaMapControlProps {
  /** @ignore */
  className?: string;
  /** @ignore */
  children?: React.ReactNode;
  /** Horizontal position. A negative value is an offset from the right. */
  x?: number;
  /** Vertical position. A negative value is an offset from the bottom. */
  y?: number;
  /** Optional inline styles applied to the outer element. */
  style?: React.CSSProperties;
}

/**
 * Positions a control on the map. Port of AquaUI's MapControl.
 */
const AquaMapControlBase = (props: IAquaMapControlProps) => {
  const x = props.x ?? 0;
  const y = props.y ?? 0;
  return (
    <div className={props.className} style={{
      left:   x >= 0 ? `${x}px`  : 'auto',
      right:  x < 0  ? `${-x}px` : 'auto',
      top:    y >= 0 ? `${y}px`  : 'auto',
      bottom: y < 0  ? `${-y}px` : 'auto',
      ...props.style
    }}>
      {props.children}
    </div>
  );
}

const AquaMapControl = styled(AquaMapControlBase)`
  position: absolute;
  z-index: 100;
  box-sizing: border-box;
  transition: right ease-out 200ms;
  // Hovered controls rise above their neighbours, so button hints aren't covered.
  &:hover {
    z-index: 101;
  }
`

export { AquaMapControl, IAquaMapControlProps }
